import { Modal } from '../ui/Modal.js';

const SHORTCUTS: Array<[string, string]> = [
  ['q', 'New task'],
  ['/', 'Search tasks'],
  ['t', 'Go to Today'],
  ['b', 'Go to Board'],
  ['Escape', 'Close / unfocus'],
  ['?', 'Toggle this overlay'],
];

export function ShortcutsOverlay({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}): React.ReactElement | null {
  return (
    <Modal open={open} onClose={onClose} title="Keyboard shortcuts" size="sm">
      <dl className="pile pile-serree">
        {SHORTCUTS.map(([key, desc]) => (
          <div key={key} className="flex items-center justify-between gap-3">
            <dt className="discret">{desc}</dt>
            <dd >
              <kbd className="touche">{key}</kbd>
            </dd>
          </div>
        ))}
      </dl>
    </Modal>
  );
}
